import React, { useState } from 'react'
import './index.scss'
import InputBox from '../../components/InputBox'
import BtnContent from '../../components/BtnContent'
const DiscountSort = props => {
    const { q, setSearchQuery, searchProducts } = props
    const resetQuery = () => {
        setSearchQuery('discountRange1', '')
        setSearchQuery('discountRange2', '')
        setSearchQuery('priceRange1', '')
        setSearchQuery('priceRange2', '')
    }
    return (
        <div className="discountSortContent">
            <div className="allInput">
                <div className="discountItem firstItem">
                    <div className="discountTitle">折扣区间</div>
                    <div className="inputContent">
                        <InputBox
                            place="0.0"
                            value={q.discountRange1 || ''}
                            onChange={e => setSearchQuery('discountRange1', e)}
                        ></InputBox>
                        <span className="line"></span>
                        <InputBox
                            place="10"
                            value={q.discountRange2 || ''}
                            onChange={e => setSearchQuery('discountRange2', e)}
                        ></InputBox>
                    </div>
                </div>
                <div className="discountItem">
                    <div className="discountTitle">价格区间（美元）</div>
                    <div className="inputContent">
                        <InputBox
                            place="最低价格"
                            value={q.priceRange1 || ''}
                            onChange={e => setSearchQuery('priceRange1', e)}
                        ></InputBox>
                        <span className="line"></span>
                        <InputBox
                            place="最高价格"
                            value={q.priceRange2 || ''}
                            onChange={e => setSearchQuery('priceRange2', e)}
                        ></InputBox>
                    </div>
                </div>
            </div>
            <BtnContent
                resetQuery={resetQuery}
                sureSearch={searchProducts}
            ></BtnContent>
        </div>
    )
}

export default DiscountSort
